<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view/>
    </transition>
    <v-dialog/>
    <notifications v-once group="main" />
    <finalCountDown :countDown="countDown" v-if="showCountDown === true"/>
    <PendingConfirmationModal v-if="showPendingConfirmationModal" :pendingConfirmationData="pendingConfirmationData" @closePendingConfirmationModal="closePendingConfirmationModal"/>
    <Poweredby class="poweredby"/>
  </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import Poweredby from '@/components/Poweredby'
import finalCountDown from '@/components/finalCountDown'
import CartController from '@/assets/controllers/CartController'
import PrinterController from '@/assets/controllers/PrinterController'
import eventModule from '@/assets/libs/eventModule'
import UpdaterController from './assets/controllers/UpdaterController'
import PaymentController from './assets/controllers/PaymentController'
import PendingConfirmationModal from '@/components/PendingConfirmationModal'
import ClarityController from '@/assets/controllers/ClarityController'
import WebsocketController from '@/assets/controllers/WebsocketController'

const TIMEOUTINMODAL = (parseInt(Util.getLocalConfigs('timeOutInModal')) || 30)
const TIMEOFINACTIVITY = (parseInt(Util.getLocalConfigs('timeOut')) || 150) + TIMEOUTINMODAL
const routsToIgnore = ['/', '/waitscreen', '/register', '/maintenance']
// const TIMEOFINACTIVITY = 60 * 3

export default {
    name: 'App',
    components: {
        finalCountDown,
        Poweredby,
        PendingConfirmationModal
    },
    data () {
        return {
            showCountDown: false,
            knowResetEvents: ['click', 'touchstart', 'touchmove', 'keypress', 'keydown', 'keyup'],
            countDown: TIMEOFINACTIVITY,
            gomLayout: Util.getLocalConfigs('utiliza_layout_gom'),
            transitionName: null,
            transitions: {
                Home: 'slide-up',
                WaitScreen: 'slide-down',
                ProductItem: 'prod-enter',
                ProductItemHome: 'backtohome',
                Checkout: 'slide-side-left',
                Payment: 'slide-side-left',
                BalancaScreen: 'slide-up',
                Pager: 'slide-side-left',
                Identification: 'slide-up'
            },
            identificationModalStatus: false,
            countDownStatus: true,
            waitingMenuUpdate: false,
            imagePrev: null,
            showPendingConfirmationModal: false,
            pendingConfirmationData: null,
            removeWebsocketRouteGuard: null
        }
    },
    watch: {
        '$route' (to, from) {
            this.transitionName = this.transitions[from.name + to.name] || this.transitions[to.name]
            if (from.name === 'Checkout' && to.name === 'Home') {
                this.transitionName = 'slide-side-right'
            }
            if (from.name === 'Payment' && to.name === 'Checkout') {
                this.transitionName = 'slide-side-right'
            }
            if (from.name === 'BalancaScreen' && to.name === 'Home') {
                this.transitionName = 'slide-side-left'
            }
            if (from.name === 'Pager' && to.name === 'Home') {
                this.transitionName = 'slide-side-right'
            }
            if (from.name === 'Pager' && to.name === 'ConsumerName') {
                this.transitionName = 'slide-side-left'
            }
            if (from.name === 'Checkout' && to.name === 'ConsumerName') {
                this.transitionName = 'slide-side-left'
            }
            if (from.name === 'ConsumerName' && to.name === 'Payment') {
                this.transitionName = 'slide-side-left'
            }
            if (from.name === 'ConsumerName' && to.name === 'Checkout') {
                this.transitionName = 'slide-side-right'
            }
            if (from.name === 'Payment' && to.name === 'ConsumerName') {
                this.transitionName = 'slide-side-right'
            }
        }
    },
    created () {
        let self = this
        document.title = this.getString('terminal_de_auto_atendimento') + ` ${process.env.VERSION}`
        Util.setLocalStoredColors()
        Util.setBackAdress()
        window.oncontextmenu = function (event) {
            event.preventDefault()
            event.stopPropagation()
            return false
        }
        if (process.env.NODE_ENV === 'production') {
            this.knowResetEvents.forEach(e => {
                document.addEventListener(e, self.resetTimeout)
            })
            self.resetTimeout()
        }
        eventModule.$on('setIdentificationModalStatus', this.setIdentificationModalStatus)
        if (this.gomLayout) {
            document.getElementsByTagName('body')[0].classList.add('gom-layout')
        }
        eventModule.$on('setCountDownTimeOut', this.setCountDownTimeOut)
        UpdaterController.startUpdaterInterval()
        if (Util.isAndroidMode()) {
            window.setImage = function (imageBase64) {
                eventModule.$emit('faceDetected', {
                    imageBase64: imageBase64
                })
            }
            window.cancelRec = function () {
                eventModule.$emit('cancelRec', '')
            }
            window.registerImage = function (imageBase64) {
                eventModule.$emit('registerImage', imageBase64)
            }
        }
        eventModule.$on('restartTimeout', this.restartTimeout)
        if (Util.isAndroidMode() && !window.LogComunication) {
            window.LogComunication = function (message) {
                console.log('Recebido do Android:', message)
                // aqui você pode chamar `this.logComunication(message)` se quiser
            }
        }
        if (Util.isTransire() && !window.onTransactionResult) {
            window.onTransactionResult = function (result) {
                PaymentController.finishTefTransire(result)
            }
        }
        if (Util.isAndroidMode() && !Util.isTransire()) {
            /* Verifica se há transações pendentes, aguarda 2 segundos para dar tempo de carregar a tela inicial */
            setTimeout(() => {
                this.checkPendingConfirmation()
            }, 2000)
        }
        ClarityController.initClarity()
        this.removeWebsocketRouteGuard = this.$router.beforeEach((to, from, next) => {
            if (!WebsocketController.isTerminalAvailable() && !WebsocketController.isMaintenanceAllowedPath(to.path) && !Util.isOracle()) {
                next('/maintenance')
                return
            }
            next()
        })
        if (!Util.isOracle()) {
            WebsocketController.connectWebSocket()
        }
    },
    beforeDestroy () {
        eventModule.$off('setIdentificationModalStatus', this.setIdentificationModalStatus)
        eventModule.$off('setCountDownTimeOut', this.setCountDownTimeOut)
        eventModule.$off('restartTimeout', this.restartTimeout)
        if (this.countDownInterval) {
            clearInterval(this.countDownInterval)
            this.countDownInterval = null
        }
        UpdaterController.stopUpdaterInterval()
        if (this.removeWebsocketRouteGuard) {
            this.removeWebsocketRouteGuard()
            this.removeWebsocketRouteGuard = null
        }
        WebsocketController.disconnectWebSocket()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        setIdentificationModalStatus: function (status) {
            this.identificationModalStatus = status
        },
        resetTimeout: function () {
            let self = this
            self.countDown = TIMEOFINACTIVITY
            clearInterval(Util.getLocalVar('countDownTimeOut'))
            self.showCountDown = false
            let countDownTimeOut = setInterval(() => {
                self.countDown -= 1
                if (self.countDown === 0 && (!routsToIgnore.includes(self.$route.path) || self.identificationModalStatus) && this.countDownStatus && process.env.NODE_ENV === 'production') {
                    self.showCountDown = false
                    CartController.resetCart()
                    if (self.identificationModalStatus) {
                        self.identificationModalStatus = false
                        eventModule.$emit('closeIdentificationModal')
                        ClarityController.stopSession()
                    }
                    if (self.$route.path !== '/') {
                        ClarityController.event('sessao_encerrada_por_timeout')
                        self.$router.push('/')
                    }
                    self.$modal.hideAll()
                }
                if (self.countDown <= TIMEOUTINMODAL && self.countDown >= 0 && ((!routsToIgnore.includes(self.$route.path)) || (self.identificationModalStatus)) && this.countDownStatus && process.env.NODE_ENV === 'production') {
                    self.showCountDown = true
                }
                if (Util.getLocalConfigs('shouldAutoClose') === true) {
                    let closingTime = Util.getLocalVar('closingTime')
                    if (closingTime && closingTime.length <= 8) {
                        Util.setLocalVar('closingTime', Util.getDateAsFormat('YYYYMMDD') + '2359')
                    }
                    if (closingTime) {
                        let beforeMidNight = closingTime < Util.getDateAsFormat('YYYYMMDDHHmm')
                        if (beforeMidNight) {
                            Util.setLocalVar('closingTime', Util.getDateAsFormat('YYYYMMDD') + '2359')
                            let curtaa = Util.getLocalConfigs('curtaa')
                            let lastClosing = curtaa && curtaa.usesOpeningLock === 'S'
                            PrinterController.relatorioFechamentoDodia(false, lastClosing)
                        }
                    } else {
                        Util.setLocalVar('closingTime', Util.getDateAsFormat('YYYYMMDD') + '2359')
                    }
                }
            }, 1000 * 1)
            Util.setLocalVar('countDownTimeOut', countDownTimeOut)
        },
        setCountDownTimeOut: function (status) {
            // habilita ou desabilita o countDown
            this.countDownStatus = status
            this.resetTimeout()
        },
        restartTimeout: function () {
            this.resetTimeout()
        },
        logComunication: function (uri, dataObject, _respose) {
            Util.logComunication(uri, dataObject, _respose)
        },
        closePendingConfirmationModal: function () {
            this.showPendingConfirmationModal = false
            this.pendingConfirmationData = null
        },
        checkPendingConfirmation: function () {
            this.pendingConfirmationData = PaymentController.getFlagStatusTef()
            if (this.pendingConfirmationData && this.pendingConfirmationData.date && this.pendingConfirmationData.value) {
                this.showPendingConfirmationModal = true
            }
        }
    }
}
</script>

<style lang='less'>
@import url("./assets/general.less");
@import (reference) url("./assets/common.less");
@import url("./assets/acessibilidade.less");
@import url("./assets/gomLayout.less");
// @import url("./assets/fonts/PoltawskiNowy.less");
@import url("./assets/fonts/Roboto.less");

h1, h2 {
    padding: 0;
    margin: 0;
}

html {
  user-select: none;
  overscroll-behavior: contain;
  body {
    height: 100vh;
    touch-action: none;
    overscroll-behavior: contain;
    font-family: @default-font;
    margin: 0;
    padding: 0;
    ul{
      padding: 0;
      margin: 0;
    }
  }
}

.slide-side-left-enter-active,
.slide-side-left-leave-active,
.slide-side-right-enter-active,
.slide-side-right-leave-active {
    transition: transform 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    will-change: transform;

}

.slide-side-left-enter {
    transform: translateX(100%);
}
.slide-side-left-leave-to {
    transform: translateX(-100%);
}

.slide-side-right-enter {
    transform: translateX(-100%);
}
.slide-side-right-leave-to {
    transform: translateX(100%);
}

.slide-side-left-enter-active, .slide-side-right-enter-active {
    z-index: 2;
}
.slide-side-left-leave-active, .slide-side-right-leave-active {
    z-index: 1;
}
#app {
    position: relative;
    height: calc(100vh - 60px);
    margin: auto 0 0 0;
    position: relative;
    overflow: hidden;
    overflow-x: hidden;
    width: 100vw;
    background: black;
}
:root {
    --white:#ffffff;
    --black:#1e1f1f;
    --primary-color:#040486;
    --primary-light:#5f96d1;
    --primary-dark:#03004F;
    --header-color:#040486;
    --cart-color: #e2e1e1;
    --cart-font-color: #1e1f1f;
    --price-font-color: #040486;
    --categorie-color: #ffffff;
    --categorie-font-color: #1e1f1f;
    --disabled-color:#cccccc;
    --gradient-color:linear-gradient(90deg, var(--primary-dark) 0%, var(--primary-color) 100%);
    --default-font: Roboto;
    // Do TAA antigo. Apagar depois de usar.
    // --confirm-color: #00A88F;
    // --grid-back-color: #f3f3f3;
}

.vue-notification {
    font-size: 2rem;
}

@media (max-width: 698px) {
    // Gertec SK210
    #app {
        height: calc(100vh - 30px);
    }
    .vue-notification {
        font-size: 16px !important;
        right: 0;
    }
    .vue-notification-group {
        top: 50% !important;
        width: 280px !important;
    }
}
@media (orientation: landscape) {
    #app {
        height: calc(100vh - 30px);
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue